import { GetterTree } from 'vuex'
import { IRootState, ISubscriptionsState, IPlan } from '@/@types'
import CONSTANTS from '@/constants'

const getters: GetterTree<ISubscriptionsState, IRootState> = {
  isOnTrialSubscription: state => {
    let isTrial = false
    if (
      state.usersCurrentSubscriptions.length > 0 &&
      state.usersCurrentSubscriptions[0]?.trial_ends_at
    ) {
      const today = new Date()
      isTrial =
        new Date(state.usersCurrentSubscriptions[0].trial_ends_at).getTime() >= today.getTime()
    }
    return isTrial
  },
  isPremiumUser: state => {
    let isPremium = false
    // Check usersCurrentSubscriptions see if there is any of PREMIUM_PLANS Constants
    const PREMIUM_PLANS = Object.values(CONSTANTS.PREMIUM_PLANS)
    if (state.usersCurrentSubscriptions.length > 0) {
      state.usersCurrentSubscriptions.map((plan: IPlan) => {
        if (PREMIUM_PLANS.includes(plan.plan_code || '')) {
          isPremium = true
        }
      })
    }
    return isPremium
  },
}

export default getters
